import { AssetManager } from './../../../assetmanager/AssetManager';
import { CountryPickerButton } from "./CountryPickerButton";
import { CountrySelectComponentEvent } from "./CountrySelectComponentEvent";
import { Country } from "@goodgamestudios/world-assignment";


import DisplayObject = createjs.DisplayObject;
import MovieClip = createjs.MovieClip;
import Sprite = createjs.Sprite;
import EventDispatcher = createjs.EventDispatcher;
import MouseEvent = createjs.MouseEvent;
// TODO: @HTML5 unhandled GlowFilter class
// import GlowFilter = createjs.GlowFilter;
import Container = createjs.Container;
import { error } from '../../../logging/error';

import { getLogger } from "@goodgamestudios/logger";

const logger = getLogger("CountrySelectComponent");

/**
 * Dropup-Box with country-Buttons to choice current country
 */
export class CountrySelectComponent extends EventDispatcher {
    private DEFAULT_COUNTRYS_PER_LINE: number = 2;
    private DEFAULT_BUTTON_OFFSET_X: number = 10;
    private DEFAULT_BUTTON_OFFSET_Y: number = 10;
    private DEFAULT_ARROW_UP: number = 1;
    private DEFAULT_ARROW_DOWN: number = 2;
    private DEFAULT_BGOFFSET_HEIGHT: number = 0;
    private DEFAULT_TOOLTIP_OFFSETX: number = 20;
    private DEFAULT_TOOLTIP_OFFSETY: number = 18;
    private DEFAULT_TOOLTIP_OFFSET: number = 20;
    //contains all available countries
    protected _countryList: Country[];
    //contains the current country
    protected _selectedCountry: Country = null;
    //filter to select a country
    // TODO: @HTML5 unhandled GlowFilter class
    // private _glowFilter: GlowFilter;
    private _glowFilter: any;
    protected _choiceCountryHeight: number;
    //contains the component as MovieClip instance
    protected _countryMC: MovieClip;
    protected _buttonOffsetX: number = this.DEFAULT_BUTTON_OFFSET_X;
    protected _buttonOffsetY: number = this.DEFAULT_BUTTON_OFFSET_Y;
    protected _bgOffsetHeight: number = this.DEFAULT_BGOFFSET_HEIGHT;
    protected _countriesPerLine: number;
    protected getTextByIDFunction: Function;
    //Tooltip instance
    protected _tooltipDisp: Container;
    //Tooltip background
    protected _tooltipBackground: Container;
    protected _tooltipOffsetX: number = this.DEFAULT_TOOLTIP_OFFSETX;
    protected _tooltipOffsetY: number = this.DEFAULT_TOOLTIP_OFFSETY;
    protected _tooltipOffset: number = this.DEFAULT_TOOLTIP_OFFSET;

    /**
     * CountryComponent
     * _countryMC includes specific drop-box-grafic, needed followed instance:
     * - mc_flagholder to added country-buttons
     * - mc_bg as background, height is calculated by the number of Buttons
     * - btn_arrow to drop up and down the box
     * - mc_currentflag to added current country-flag (without buttonfunction)
     *
     * @param countryMC contains the component as MovieClip instance
     * @param toolTipMC contains the toolTip view
     * @param countryList contains all available countries
     * @param countriesPerLine the amount of countries per line in the component
     */
    constructor(countryMC: MovieClip, toolTipMC: MovieClip, countryList: Country[], countriesPerLine?: number, getTextByID: Function = null) {
        super();
        if (countriesPerLine === undefined) {
            countriesPerLine = this.DEFAULT_COUNTRYS_PER_LINE;
        }
        this._countryMC = countryMC;
        this._tooltipBackground = toolTipMC;
        this._countryList = countryList;
        this._countriesPerLine = countriesPerLine;
        this.getTextByIDFunction = getTextByID;
        // TODO: @HTML5 unhandled GlowFilter class
        // this._glowFilter = new GlowFilter("#FFFFFF");
        // initialize the compnent with all available countries in countryList
        this.addCountryButtons();
        this.countryMC.btn_arrow.addEventListener(MouseEvent.CLICK, this.bindFunction(this.toggleCountryPopUp));
    }

    /**
     * removes the EventListener toggleCountryPopUp
     */
    public destroy(): void {
        this.countryMC.btn_arrow.removeEventListener(MouseEvent.CLICK, this.bindFunction(this.toggleCountryPopUp));

        let tempChild: DisplayObject;
        let i: number;
        let childNum: number = this.countryMC.mc_flagholder.numChildren;

        for (i = 0; i < childNum; ++i) {
            tempChild = this.countryMC.mc_flagholder.getChildAt(i);

            tempChild.removeEventListener(MouseEvent.MOUSE_OVER, this.bindFunction(this.showCountryNameTooltip));
            tempChild.removeEventListener(MouseEvent.MOUSE_OUT, this.bindFunction(this.hideCountryNameTooltip));
        }
    }

    /**
     * drop up or down the Country-Choice-Box
     */
    protected toggleCountryPopUp(event: MouseEvent): void {
        if (this.countryMC.mc_bg.scaleY > 1) {
            this.hideChoiceCountry(); //hide the mc_flagholder
        }
        else {
            this.showChoiceCountry(); //display the mc_flagholder
        }
    };

    /**
     * added all country Buttons by available countries (define in countryList)
     * country-button instance called "country_" + country.ggsCountryCode, example: country_DE
     * to use getDefinitionByName set up in additional compiler args -include-libraries PATH_TO_SWC
     *
     * @param countryList all available countries to reset the DisplayList of all country buttons
     */
    protected addCountryButtons(countryList: Country[] = null): void {
        if (countryList) {
            this._countryList = countryList; //reset the view of all countryButtons
        }

        while (this.countryMC.mc_flagholder.numChildren > 0) //removes childs and listener if reset the view
        {
            this.countryMC.mc_flagholder.getChildAt(0).removeEventListener(MouseEvent.CLICK, this.bindFunction(this.onClickCountry));
            this.countryMC.mc_flagholder.removeChildAt(0);
        }
        this.countryMC.mc_flagholder.visible = false; //hide the mc_flagholder

        if (this._countryList.length == 1) {
            this._countryMC.visible = false;
            logger.debug("Hiding the Language Selection since we only have 1 language available!");
        }

        //generates all instances of flags
        for (let i: number = 0; i < this._countryList.length; i++) {
            let country: Country = this._countryList[i];

            try {
                let mcClass: any = (<any>AssetManager.manager.getClass("country_" + country.ggsCountryCode));
                let countryFlag: MovieClip = new mcClass(); //Instance of the flag

                if (countryFlag) {
                    let btn: CountryPickerButton = new CountryPickerButton();
                    btn.addChild(countryFlag);

                    btn.country = country;
                    btn.name = "country_" + country.ggsCountryCode;
                    btn.mouseChildren = false;

                    btn.addEventListener(MouseEvent.CLICK, this.bindFunction(this.onClickCountry));
                    //listener for popUpEvent
                    btn.addEventListener(MouseEvent.MOUSE_OVER, this.bindFunction(this.showCountryNameTooltip));
                    btn.addEventListener(MouseEvent.MOUSE_OUT, this.bindFunction(this.hideCountryNameTooltip));

                    this.countryMC.mc_flagholder.addChild(btn);
                }
            }
            catch (e) {
                error("country unkown: " + country.ggsCountryCode);
            }
        }
        this.positionCountryBtn(); //positioned all buttons
        this.hideChoiceCountry(); //hide the mc_flagholder
    }

    /**
     * is executed when mouse is over a flag
     * shows a popUp with vector font of country
     */
    protected showCountryNameTooltip(event: MouseEvent): void {
        //get the flag
        let countryBtn: MovieClip = (<MovieClip>event.currentTarget);

        try {
            //vector font
            let mcClass: any = (<any>AssetManager.manager.getClass("CountryName_" + (countryBtn as any).country.ggsCountryCode));
            let CountryNameText: MovieClip = new mcClass();
            //resize the background
            this._tooltipBackground.width = CountryNameText.width + this._tooltipOffsetX;
            this._tooltipBackground.height = CountryNameText.height + this._tooltipOffsetY;
            //position in the middle of the background
            CountryNameText.y = -(this._tooltipOffsetY / 3);
            //instantiate new popUp
            this._tooltipDisp = new Container();
            //create popUp view
            this._tooltipDisp.addChild(this._tooltipBackground);
            this._tooltipDisp.addChild(CountryNameText);
            //position the popUp above the flag
            this._tooltipDisp.x = countryBtn.x;
            this._tooltipDisp.y = countryBtn.y - this._tooltipOffset;
            //add the current popUp to the flagholder
            this.countryMC.mc_flagholder.addChild(this._tooltipDisp);
        }
        catch (e) {
        }
    };

    /**
     * is executed when mouse is leaving a flag
     * close the popUp view
     */
    protected hideCountryNameTooltip(event: MouseEvent): void {
        if (this._tooltipDisp) {
            //remove the Tooltip view
            this.countryMC.mc_flagholder.removeChild(this._tooltipDisp);
            this._tooltipDisp = null;
        }
    };

    /**
     * is executed when choice a country
     */
    protected onClickCountry(event: MouseEvent): void {
        let selectedCountry: Country = (<Country>event.target.country);
        this.selectedCountryButton(selectedCountry);
        this.hideChoiceCountry(); //hide the mc_flagholder
    };

    /**
     * set position by number of country-buttons
     * default is two in a row
     */
    protected positionCountryBtn(): void {
        //positioned all country buttons
        for (let i: number = 0; i < this.countryMC.mc_flagholder.numChildren; i++) {
            let child: MovieClip = (<MovieClip>this.countryMC.mc_flagholder.getChildAt(i));

            if (!child) {
                continue;
            }
            child.x = (child.width + this._buttonOffsetX) * (i % this._countriesPerLine);
            child.y = (child.height + this._buttonOffsetY) * Math.floor(i / this._countriesPerLine) + 12;
            this._choiceCountryHeight = (child.height + child.y);
        }
        this.countryMC.mc_flagholder.y = -(this._choiceCountryHeight + this.countryMC.mc_bg.height);
    }

    /**
     * close the view of all available countries
     */
    public hideChoiceCountry(): void {
        this.countryMC.mc_flagholder.visible = false;
        this.countryMC.mc_bg.scaleY = 1;
        this.countryMC.btn_arrow.gotoAndStop(this.DEFAULT_ARROW_UP);
        this.dispatchEvent(new CountrySelectComponentEvent(CountrySelectComponentEvent.COUNTRY_VIEW_CLOSED));
    }

    /**
     * open the view of all available countries
     */
    public showChoiceCountry(): void {
        this.countryMC.mc_flagholder.visible = true;
        let height: number = this.countryMC.mc_bg.height + this._choiceCountryHeight - this.countryMC.mc_currentflag.y + this._bgOffsetHeight;
        this.countryMC.mc_bg.scaleY = height / this.countryMC.mc_bg.height;
        this.countryMC.btn_arrow.gotoAndStop(this.DEFAULT_ARROW_DOWN);
        this.dispatchEvent(new CountrySelectComponentEvent(CountrySelectComponentEvent.COUNTRY_VIEW_OPENED));
    }

    /**
     * change mc_currentflag and select the pressed button
     *
     * @param country as string
     */
    protected selectedCountryButton(country: Country): void {
        // Sanity check: If there is no list or the list contains only zero or 1 element hide the whole component
        if (!this._countryList || this._countryList.length <= 1) {
            this.countryMC.visible = false;
            return;
        }

        //_selectedCountry changed
        if (!this._selectedCountry || this._selectedCountry.ggsCountryCode != country.ggsCountryCode) {
            this.selectChild(this.countryMC.mc_flagholder.getChildByName("country_" + country.ggsCountryCode)); //is used to set up the GlowFilter

            //if (this._selectedCountry) {
            //    this.deselectedChild(this.countryMC.mc_flagholder.getChildByName("country_" + this._selectedCountry.ggsCountryCode));
            //} //is used to remove the GlowFilter

            while (this.countryMC.mc_currentflag.numChildren > 0) //is used to remove the currentFlag
                this.countryMC.mc_currentflag.removeChildAt(0);
            let mcClass: any = (<any>AssetManager.manager.getClass("country_" + country.ggsCountryCode)); //instance of the currentFlag
            let countryBtn: MovieClip = new mcClass();

            if (countryBtn) {
                countryBtn.name = country.ggsCountryCode; //set up the name of the instance
                this.countryMC.mc_currentflag.addChild(countryBtn); //display the current country
            }
            this._selectedCountry = country; //set up the current country
            this.dispatchEvent(new CountrySelectComponentEvent(CountrySelectComponentEvent.COUNTRY_CHANGED, this._selectedCountry));
        }
    }

    /**
     * set up the default country in mc_currentflag
     *
     * @param country as String
     */
    public setDefaultCountry(country: Country): void {
        this.selectedCountryButton(country);
    }

    /**
     * Applies the glow filter for a selected country button
     *
     * @param child as MovieClip
     */
    protected selectChild(child: MovieClip): void {
        child.filters = [this._glowFilter];
    }

    /**
     * Removes the glow filter of a formerly selected country button
     *
     * @param child as MovieClip
     */
    protected deselectedChild(child: MovieClip): void {
        if (child.filters.length > 0) {
            child.filters = [];
        }
    }

    /**
     * use to set up the GlowFilter
     *
     * @param glowFilter as GlowFilter
     */
    // TODO: @HTML5 unhandled GlowFilter class
    // public set glowFilter(glowFilter: GlowFilter) {
    public set glowFilter(glowFilter: any) {
        this._glowFilter = glowFilter;
    }

    /**
     * In createjs MovieClip cannot use dynamic parameters
     * @returns {any}
     */
    private get countryMC(): MovieClip {
        return this._countryMC;
    }
}
